import { Injectable } from '@angular/core';
import { ResponderService } from '../../api/services/responder.service';

import {map} from "rxjs/operators";

@Injectable()
export class RespondersService {

  constructor(private apiService: ResponderService) {}

  searchResponders(searchCriteria: any) {
    let ssn = searchCriteria.socialSecurityNumber || '';
    let last4 = ssn.substr(ssn.length - 4, 4);
    let params= {findKeys:{
      Page: searchCriteria.pageNumber,
      TeamKey: searchCriteria.team,
      SsnLastFour: last4,
      LastName: searchCriteria.lastName,
      FirstName: searchCriteria.firstName,
      ShowAll: 'false'}
    };

    return this.apiService.FindInDomain(params).pipe(map((viewModel: any) => {
      return viewModel;
    }));
  }


}
